import Env from '../../base/env'
import Channels from '../../base/channels'
import normalizeWheel from 'normalize-wheel'
import Barba from 'barba.js'

export default class MarqueeInfinite
{
    constructor(view) {
        // DOM
        if(view == null) return false
        this.container = view
        this.view = view.querySelector('.jsMarqueeInfinite--view')
        this.$cells = this.view.querySelectorAll('.jsCell')
        this.$canvas = this.view.querySelector('.about-clients__canvas')
        this.$items = []
        this.renderers = []
        // States
        this.scrollValue = 0
        this.cellsWidth = []
        // PIXI
        this.context = this.$canvas.getBoundingClientRect()
        this.dMapSprite =  manifestImg.dMapLauncher
        this.ticker = new PIXI.ticker.Ticker()
        this.refHover = false
        // Flags
        this.INERTIA = (Env.isTouch === true)?10:3.5
        this.ENABLED = false
        this.SPEED = .5
        this.SPEED_DELTA = 8
        // Fns
        this.fnWheel = this.wheel.bind(this)
        this.fnResize = this.resize.bind(this)
        this.fnSwipe = this.swipe.bind(this)
    }

    draw()
    {
        let css = {
            fill: '#fff',
            fontFamily: 'PostGrotesk-Light,sans-serif',
            fontSize:80,
            letterSpacing:0,
            lineHeight: 36,
            padding : 5
        }
        if(Env.mobileCSS === true) {
            css.fontSize = 36
        }

        //Dmap
        this.displacementSprite = new PIXI.Sprite.fromImage( this.dMapSprite )
        this.displacementSprite.texture.baseTexture.wrapMode = PIXI.WRAP_MODES.REPEAT;
        this.displacementSprite.anchor.set(0.5);
        this.displacementSprite.x = 20
        this.displacementSprite.y = 20
        this.displacementSprite.scale.x = 1
        this.displacementSprite.scale.y = 1
        this.displacementFilter = new PIXI.filters.DisplacementFilter( this.displacementSprite )
        this.displacementFilter.scale.x = 0;
        this.displacementFilter.scale.y = 0;
        this.displacementFilter.autoFit = false;

        // Hover
        this.theviewport = Env.framework.toolbox.getViewport()
        this.rendererHover = new PIXI.autoDetectRenderer({width : this.theviewport.width  , height : this.theviewport.height , transparent: true })
        this.$canvas.appendChild( this.rendererHover.view );
        this.rendererHover.interactive = false
        this.rendererHover.view.style.pointerEvents = 'none'
        this.rendererHover.view.x = 0
        this.stageHover = new PIXI.Container()
        this.textHover = new PIXI.Text('',css)
        this.textHover.anchor.set(0)
        this.textHover.filters = [this.displacementFilter];
        this.stageHover.addChild( this.displacementSprite );
        this.stageHover.addChild(this.textHover)
        this.rendererHover.render( this.stageHover );


        let posTop = 0
        for(let c = 0; c < this.$cells.length; c++) {
            const cell = this.$cells[c]
            const $items = cell.querySelectorAll('.jsItem')
            let arraysItems = []
            let posLeft = 0
            for(let i = 0; i < $items.length; i++) {
                let item = $items[i]
                const dimensions = item.getBoundingClientRect()

                let renderer = new PIXI.CanvasRenderer({width : dimensions.width  , height : dimensions.height + 40 , transparent: true })
                let stage = new PIXI.Container()
                this.$canvas.appendChild( renderer.view );
                renderer.view.style.left = `${posLeft}px`
                renderer.view.style.top = `${posTop}px`
                renderer.view.x = 0

                const newText = new PIXI.Text(item.innerHTML,css)
                newText.anchor.set(0)
                newText.alpha = 1
                newText.interactive = true

                // Events
                newText.click = ()=>{
                    if(item.classList.contains('can--hover') === true) {
                        Barba.Pjax.goTo(item.getAttribute('href'))
                    }
                }
                newText.mouseover = ()=> {
                    TweenLite.to(this.displacementFilter.scale , .5 , { x : 15 , y : 10 , ease : Cubic.easeOut })
                    newText.alpha = 0
                    this.refHover = renderer.view
                    this.textHover.text = item.innerHTML
                    renderer.render( stage );
                }
                newText.mouseout = ()=> {
                    newText.alpha = 1
                    renderer.render( stage );
                    TweenLite.to(this.displacementFilter.scale , .5 , { x : 0 , y : 0 , ease : Cubic.easeOut , onComplete:()=>{
                            this.refHover = false
                            this.textHover.text = ''
                        }
                    })
                }
                stage.addChild(newText)
                renderer.render( stage );

                this.renderers.push(renderer)
                arraysItems.push(renderer.view)
                posLeft += dimensions.width
            }
            if(Env.mobileCSS === true) {
                posTop += 45
            } else {
                posTop += 80
            }
            this.cellsWidth.push(posLeft)
            this.$items.push(arraysItems)
            this.enable()
        }

    }

    disable()
    {
        this.ENABLED = false
    }

    destroy()
    {
        for(let i = 0; i < this.renderers.length; i++) {
            const renderer = this.renderers[i]
            renderer.destroy()
        }
        setTimeout(() => {
            this.ticker.destroy()
            this.rendererHover.destroy()
        }, 800);

        this.disable()
        // Channels.removeListener('window::smartresize', this.fnResize);
    }

    enable()
    {
        this.ENABLED = true
    }

    events()
    {

        // Channels.on('window::smartresize',this.fnResize)

        if(Env.isTouch === true) {
             // SWIPE
            this.container.addEventListener('touchstart', this.fnSwipe , false);
        } else {
            this.container.addEventListener('wheel', this.fnWheel,true); // for Firefox
            this.container.addEventListener('mousewheel', this.fnWheel,true); // for everyone else
        }

        const $hovers = this.view.querySelectorAll('.jsItem')
        for(let i = 0; i < $hovers.length; i++) {
            const $hover = $hovers[i]
            $hover.addEventListener('mouseenter',()=>{
                Env.$html.classList.add('marquee--isHovered')
            })
            $hover.addEventListener('mouseleave',()=>{
                Env.$html.classList.remove('marquee--isHovered')
            })
        }
    }

    move(item,fullWidth,viewport,direction = 1)
    {
        if(item !== null) {

            const position = item.getBoundingClientRect()
            // if card is going to left and go off of screen
            if(position.right < 0) {
                item.x += fullWidth
            // if card is going to right and go out of screen
            } else if(position.left > viewport.width) {
                item.x -= fullWidth
            }
            // Scrolling
            if(direction > 0) {
                item.x -= this.scrollValue
            } else if(direction < 0) {
                item.x += this.scrollValue
            }
            TweenLite.set(item , { x : item.x , force3D : true })
        }
    }

    onWatch()
    {
        if(this.ENABLED === true) {
            // Context
            const viewport = Env.framework.toolbox.getViewport()
            this.scrollValue += (this.SPEED  - this.scrollValue) / this.INERTIA
            // Items line 1
            for(let i = 0; i < this.$items[0].length; i++) {
                const item = this.$items[0][i]
                this.move(item,this.cellsWidth[0],viewport)
            }
            // Items line 2
            for(let j = 0; j < this.$items[1].length; j++) {
                const item = this.$items[1][j]
                this.move(item,this.cellsWidth[1],viewport,-1)
            }

            // Hover text position
            if(typeof this.refHover !== 'undefined' && this.refHover !== false) {
                this.rendererHover.view.style.left = this.refHover.style.left
                this.rendererHover.view.style.top = this.refHover.style.top
                TweenLite.set(this.rendererHover.view , { x : this.refHover.x , force3D : true })
            }
        }
    }

    resize()
    {

    }

    render()
    {
        this.ticker.add((delta)=>{
            this.onWatch()

            this.displacementSprite.x += 5 * (delta / this.SPEED_DELTA);
            this.displacementSprite.y += 3 * (delta / this.SPEED_DELTA);
            this.rendererHover.render( this.stageHover );

        });
    }

    setup()
    {

        this.draw()
        this.events()
        this.start()
        this.render()
    }

    swipe(event)
    {
        const swipe = event.touches
        const start = swipe[0].pageY
        this.container.addEventListener('touchmove', (event)=> {
            const touch = event.touches
            const end = touch[0].pageY
            const distance = end - start;
            this.scrollValue = distance
        },false)
    }

    start()
    {
        this.ticker.start()
    }

    stop()
    {
        this.ticker.stop()
    }

    wheel(event)
    {
        const normalized = normalizeWheel(event);
        this.scrollValue = normalized.pixelY
    }

}